<template>
    <div class="p-5">
        <h1 class="text-5xl text-slate-600 font-bold font-medium tracking-tight">Style Guide</h1>
    </div>
</template>

<script>
export default {
    name: 'StyleGuideHome',
    props: ['prop1', 'prop2'],
    data () {
        return {
            model: webase.model
        }
    },
    mounted () {
    },
    methods: {
        importantMethodHere () {
        }
    }
}
</script>
